import { render, staticRenderFns } from "./faqbusiness.vue?vue&type=template&id=048aac48&"
import script from "./faqbusiness.vue?vue&type=script&lang=js&"
export * from "./faqbusiness.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports